<template>
        <div>
            <b-card style="border: none; margin-left: 2rem; margin-right: 2rem">
                <b-row>
                    <b-col md="8">
                        <label for="title">Betreff</label>
                        <b-form-input id="title" type="text"
                                      v-model="title"
                                      placeholder="Tragen Sie hier den Betreff ein."
                                      class="mb-2"
                                      maxlength="50"
                                      aria-describedby="input-live-help"
                        ></b-form-input>
                        <b-form-text id="input-live-help" style="text-align: right">{{title.length}}/50</b-form-text>
                        <label for="description">Beschreibung</label>
                        <b-form-textarea
                                id="description"
                                class="text-black"
                                placeholder="Beschreiben Sie Ihren Auftrag."
                                rows="11"
                                max-rows="11"
                                wrap="hard"
                                v-model="description"

                        ></b-form-textarea>
                    </b-col>
                    <b-col md="4">
                        <b-row>
                            <b-col md="6">
                        <label for="date">Zieldatum</label>
                        <datetime
                                v-model="due"
                                input-class="form-control mb-2"
                                input-style="color: black;"
                                input-id="date"
                                :phrases="datetimeConfig.phrases"
                                :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                                :min-datetime="datetimeConfig.minTime"></datetime>
                            </b-col>
                            <b-col md="6">
                                <label for="zeitart">Datumsart</label>
                                <b-form-select :options="z_select" id="zeitart" :plain="true"
                                               v-model="zeitart"
                                               disabled
                                               class="mb-2 text-black"></b-form-select>
                            </b-col>
                        </b-row>
                        <label for="dringlich">Dringlichkeit</label>
                        <b-form-select :options="d_select" id="dringlich" :plain="true"
                                       v-model="dringlich"
                                       class="mb-2 text-black"></b-form-select>
                        <label v-if="false" for="typ">Typ</label>
                        <b-form-select v-if="false" :options="t_select" id="typ" :plain="true"
                                       v-model="typ"
                                       class="mb-2 text-black"></b-form-select>
                        <!--label v-if="!hasDataId" for="a_geber">Zuständigkeit</label-->
                      <b-form-group
                          id="fieldset-1"
                          label="Zuständigkeit"
                          label-for="a_geber"
                          :invalid-feedback="'Bitte wählen Sie die Zuständigkeit aus'"
                          :state="a_geber !== undefined"
                      >
                        <b-form-select v-if="!hasDataId" :options="a_select" id="a_geber" :plain="true"
                                       v-model="a_geber"
                                       class="mb-2 text-black"></b-form-select>
                      </b-form-group>
                        <label v-if="!hasDataId" for="s_bearbeiter">Sachbearbeiter</label>
                        <b-form-input v-if="!hasDataId" id="s_bearbeiter" type="text"
                                      v-model="s_bearbeiter"
                                      disabled
                                      class="mb-2"
                        ></b-form-input>
                        <div v-if="c_select.length>0">
                        <label for="commune">Kommune</label>
                        <b-form-select :options="c_select" id="commune" :plain="true"
                                       v-model="commune"
                                       class="mb-2 text-black"></b-form-select>
                        </div>
                    </b-col>

                </b-row>
            </b-card>
        </div>
</template>

<script>
    import {DateTime as LuxonDateTime} from 'luxon'
    import {Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
    import {decryptAES, decryptArray, encryptAES, encryptMultipleAES} from "@/shared/crypto";

    export default {
        name: "task_step1",
        props: ['currentStep'],
        mounted() {
            this.$emit('can-continue', {value: false});
            //this.a_geber = this.currentStep.payload.a_geber[0];
            //this.a_select = this.currentStep.payload.a_geber;
        },
        created() {
            if (this.$route.query.data_id !== undefined) {
                this.hasDataId = true;
                this.dataId = this.$route.query.data_id;
            }
          if (this.$route.query.entity_id !== undefined) {
            this.entityId = this.$route.query.entity_id;
          }
            if (this.$route.query.message_payload !== undefined) {
              let messagePayloadId = this.$route.query.message_payload;
              let payload = JSON.parse(sessionStorage.getItem(messagePayloadId));
              // todo do later when user leaves site
              //sessionStorage.removeItem(messagePayloadId);
              this.roomId = payload.roomId;
              this.messages = payload.messages
            }
            this.isEncrypted = sessionStorage.getItem("aes") !== null;
            this.showLoader();
            let data = {};
            if (this.roomId) {
              data.room_id = this.roomId;
              data.messages = this.messages;
            }
            this.$http.get(
                Server_URL+'/auftragsbuch/data/create/step1' + (this.hasDataId ? "?data_id="+this.dataId : "") + (this.entityId ? "?entity_id="+this.entityId : ""), {params: data}
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
                loader: undefined,
                a_geber: undefined,
                s_bearbeiter: "",
                title: "",
                due: null,
                dringlich: "stufe1",
                typ: "0",
                description: "",
                zeitart: "Tag",

                z_select: ["Tag", "Kalendarwoche"],
                a_select: [],
                d_select: [{text: "normal", value: "stufe1"}, {text: "hoch", value: "stufe2"}],
                t_select: [{text: "Auftrag - Einzelrechnung", value: "0"}, {text: "Aufgabe - Sammelrechnung", value: "1"}],
                datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
                dropOptions: {
                    url: "https://httpbin.org/post",
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    dictDefaultMessage: "<i class='icon-cloud-upload icon font-4xl mr-3 mt-3'></i>",
                    dictRemoveFile: "Entfernen",

                },
                groups: [],
                session: {},
                settings: {},
                isEncrypted: false,

                // todo use later
                c_select: [],
                commune: "",
                hasDataId: false,
                dataId: "",
                anlagen: "",
                messages: [],
                roomId: null,
                files: [],

              // for planning the task
              canAccept: false,
              canPlan: false,
              legrs: [],
              bhStructure: [],

              // cadastre
              entityId: undefined,
              aufisn: undefined,
              augr: undefined,
            }
        },
        watch: {
            title: function(val) {
                if (val === "") {
                    this.$emit('can-continue', {value: false});
                } else if (this.a_geber !== undefined) {
                    this.$emit('can-continue', {value: true});
                }
            },
          a_geber: function(val) {
            if (val === undefined) {
              this.$emit('can-continue', {value: false});
            } else if (this.title !== "") {
              this.$emit('can-continue', {value: true});
            }
          },
            commune: function (val) {
                if (val === "" && this.c_select.length > 0) {
                    this.$emit('can-continue', {value: false});
                } else if (this.title !== "") {
                    this.$emit('can-continue', {value: true});
                }
            }
        },
        methods: {
            setActive(val) {},
            getReturnData: function () {
                return {
                    betreff: this.title,
                    beschreibung: this.description,
                    date: this.due,
                    kw: "",
                    dringlich: this.dringlich,
                    typ: this.typ,
                    abteilung: this.a_geber.name,
                    selected_group: this.a_geber,
                    settings: this.settings,
                    commune: "",
                    anlagen: this.anlagen,
                    message_files: this.files,
                    canAccept: this.canAccept,
                    canPlan: this.canPlan,
                    legrs: this.legrs,
                    bhStructure: this.bhStructure,
                    augr: this.augr,
                    aufisn: this.aufisn
                };
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200 && response.body.status === "ok") {
                    this.session = response.body.session;
                    this.groups = response.body.data.groups;
                    this.settings = response.body.data.settings;
                    this.s_bearbeiter = this.session.full_name;
                    this.canAccept = response.body.data.canAccept;
                    this.canPlan = response.body.data.canPlan;
                    this.legrs = response.body.data.legrs;
                    this.bhStructure = response.body.data.bhStructure;
                    if (this.isEncrypted) {
                        let res = JSON.parse(sessionStorage.getItem(this.session.id));
                        if (res !== null) {
                            this.s_bearbeiter = res.first_name + " " + res.surname;
                        }
                    }

                    for (let i = 0; i < this.groups.length; i++) {
                        let res = JSON.parse(sessionStorage.getItem(this.groups[i].name));
                        if (res !== null) {
                            this.a_select.push({text: res.username, value: this.groups[i]});
                        } else {
                            this.a_select.push({text: this.groups[i].name, value: this.groups[i]});
                        }
                    }
                    if (this.groups.length <= 2) {
                      this.a_geber = this.groups[0];
                    } else {
                      this.a_geber = undefined;
                    }
                    this.messages = response.body.data.messages;
                    this.files = response.body.data.files;
                    if (this.messages && this.messages.length) {
                      decryptArray(sessionStorage.getItem("aes"), this.messages).then(res => {
                        this.messages = res;
                        let desc = "";
                        for (let i = 0; i < this.messages.length; i++) {
                          desc += this.messages[i] + "\n";
                        }
                        this.description = desc;
                      }).catch(res => {
                        console.log(res)
                      })
                    }
                    if (this.hasDataId) {
                        let data = response.body.data.data;
                        this.title = data.gi_auf_ext;
                        this.due = data.ziel_datum;
                      if (sessionStorage.getItem("aes") !== null) {
                        decryptAES(sessionStorage.getItem("aes"), data.gi_memo).then(res => {
                          this.description = res;
                        }).catch(res => {
                          this.description = data.gi_memo;
                        })
                      } else {
                        this.description = data.gi_memo;
                      }
                        this.anlagen = data.anlagen;
                    }
                    if (this.entityId && response.body.data.augr && response.body.data.aufisn) {
                        this.augr = response.body.data.augr;
                        this.aufisn = response.body.data.aufisn;
                    }
                } else {                   window.location = Redirect_500;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    window.location = Redirect_500;
                }
            },
        }
    }
</script>

<style scoped>
    .form-control:disabled {
        color: black;
    }

    .text-black {
        color: black;
    }
</style>
